import { useCallback, useContext, useState } from 'react';
import { useRouter } from 'next/router';
import { showNotification } from '@mantine/notifications';

import { ContestManageContext } from '../context/ContestManageContext';

export const useInitialSubmit = () => {
  const { values } = useContext(ContestManageContext);
  const [isSubmitLoading, setIsSubmitLoading] = useState(false);
  const router = useRouter();

  const handleSubmit = useCallback(async () => {
    setIsSubmitLoading(true);

    try {
      const selectedLeagueId = values?.init?.leagueId;
      const selectedContestTemplateId = values?.init?.contestTemplateId;

      if (!selectedLeagueId || !selectedContestTemplateId) {
        showNotification({
          title: 'Missing Information',
          message: 'Please select both a league and contest type to continue.',
          color: 'orange.3',
          autoClose: 5000,
        });
        setIsSubmitLoading(false);
        return;
      }

      await router.replace({
        pathname: '/contest/create',
        query: {
          leagueId: selectedLeagueId,
          contestTemplateId: selectedContestTemplateId,
        },
      });
    } catch (error) {
      console.error('Error during initial submit:', error);
      showNotification({
        title: 'Something went wrong',
        message: 'Please try again.',
        color: 'orange.3',
        autoClose: 5000,
      });
      setIsSubmitLoading(false);
    }
  }, [values, router]);

  return {
    isSubmitLoading,
    onSubmit: handleSubmit,
    isSubmitSuccess: false,
    isDiscardChangesModalOpen: false,
    onDiscardChangesModalClose: () => {},
    onDiscardChangesModalConfirm: () => {},
    data: null,
  };
};
